// extracted by mini-css-extract-plugin
export default {"body":"_-_-record-it-components-src-modal-ConfirmModalBody-__body"};